import { Alert, AlertDescription, AlertIcon, Text } from '@chakra-ui/react';
import { Trans } from '@lingui/react/macro';

export function SemesterCompletionAlert() {
  return (
    <Alert status="info" borderRadius="md" p={4} alignItems="flex-start">
      <AlertIcon />
      <AlertDescription>
        <Text>
          <Trans>
            This will result in this semester for this enrolment being assessed as{' '}
            <strong>complete</strong>.
          </Trans>
        </Text>
        <Text mt={4}>
          <Trans>Documents will be issued immediately</Trans>
        </Text>
      </AlertDescription>
    </Alert>
  );
}
